import { CardActionArea, CardActionAreaProps } from '@mui/material'
import { NavigateProps } from 'react-router-dom'
import { HoverableCard, HoverableCardProps } from '../HoverableCard'

interface MaybeCardActionAreaProps
  extends Pick<CardActionAreaProps, 'onClick' | 'disabled' | 'LinkComponent'>,
    Partial<NavigateProps> {}

const MaybeCardActionArea: React.FC<MaybeCardActionAreaProps> = ({
  children,
  LinkComponent,
  onClick,
  ...rest
}) => (
  <CardActionArea
    {...rest}
    LinkComponent={LinkComponent}
    onClick={onClick}
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      pointerEvents: rest.disabled ? 'none' : undefined,
    }}
  >
    {children}
  </CardActionArea>
)

export type ClickableCardProps = Omit<HoverableCardProps, 'onClick'> & MaybeCardActionAreaProps

export const ClickableCard: React.FC<ClickableCardProps> = ({
  children,
  LinkComponent,
  onClick,
  scale,
  ...props
}) => (
  <HoverableCard scale={scale} {...props} disabled={props.disabled || (!onClick && !LinkComponent)}>
    <MaybeCardActionArea onClick={onClick} LinkComponent={LinkComponent} {...props}>
      {children}
    </MaybeCardActionArea>
  </HoverableCard>
)
